'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatLineSpacing = function EditorFormatLineSpacing(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z' })
  );
};
EditorFormatLineSpacing = (0, _pure2.default)(EditorFormatLineSpacing);
EditorFormatLineSpacing.displayName = 'EditorFormatLineSpacing';
EditorFormatLineSpacing.muiName = 'SvgIcon';

exports.default = EditorFormatLineSpacing;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/editor/format-line-spacing.js
// module id = 2237
// module chunks = 0